import React, { useState } from 'react';
import {
  plantMetadataInLocalStorageAndReturnTransferUrl,
  setPartnerNameAndImageWithId,
  convertProps,
} from 'partial/OfferManager/holder/genericOfferLogic';
import { fetchApplyNowTracking } from 'externals/_services/tracking.service';
import { withRouter } from 'react-router-dom';
import { getFullAttributes } from 'helpers/tracking.helpers';
import {
  CLICK_APPLY,
  SEEN_OFFER,
} from 'externals/_tracking/types/eventTypes.constants';
import VisibilitySensor from 'react-visibility-sensor';
import useTrackingMetadata from 'externals/_tracking/useTrackingMetadata';
import { useLogger } from 'hook/error.hook';
import { useDispatch } from 'react-redux';
import { wrapService } from 'actions/service_wrapper.actions';
import { getMrphPageFormFactor } from 'helpers/metadataLogic.helpers';

const a_fetchApplyNowTracking = wrapService(fetchApplyNowTracking, {
  name: 'bl_fetchApplyNowTracking',
});

const BusinessLoanOfferHolder = props => {
  const [isSeenTriggered, setIsSeenTriggered] = useState(false);
  const trackingManager = useTrackingMetadata();
  const { pageNameMeta } = trackingManager;
  const logger = useLogger({
    name: 'BusinessLoanOfferHolder',
  });
  const dispatch = useDispatch();

  const defaultEventHandler = (name, attributes = {}) => {
    const fullAttributes = getFullAttributes({
      partner: props.partner,
      pagePosition: props.pagePosition,
      modulePosition: props.modulePosition,
      offerMetadata: props.offerMetadata,
      position: props.position,
      extraAttributes: props.extraAttributes,
      attributes: attributes,
    });
    props.eventHandler(name, fullAttributes);
  };

  function onApplyClick(e) {
    e.preventDefault();
    __onApplyClick({
      'Click Type': 'Apply',
    });
  }

  function onApplyClickForImage(e) {
    e.preventDefault();
    __onApplyClick({
      'Click Type': 'Business Loan Image',
    });
  }

  function onApplyClickForName(e) {
    e.preventDefault();
    __onApplyClick({
      'Click Type': 'Business Loan Name',
    });
  }

  const __onApplyClick = extraAttributes => {
    const offerDetails = props.offerMetadata;
    const id = setPartnerNameAndImageWithId(
      offerDetails.name,
      offerDetails.logoUrl || offerDetails.logoLink,
    );

    let attributes = Object.assign(
      {
        'Click Type': 'Apply',
        'Page Name': pageNameMeta,
        'Page Form Factor': getMrphPageFormFactor(),
      },
      extraAttributes,
    );

    const propsForBackend = convertProps(
      getFullAttributes({
        partner: props.partner,
        pagePosition: props.pagePosition,
        modulePosition: props.modulePosition,
        offerMetadata: props.offerMetadata,
        position: props.position,
        extraAttributes: props.extraAttributes,
        attributes: attributes,
        containerType: props.containerType,
        includeBackendRefCode: true,
      }),
    );

    let windowReference = window.open();
    dispatch(
      a_fetchApplyNowTracking(offerDetails.linkUrl, { props: propsForBackend }),
    )
      .then(trackingMetadata => {
        defaultEventHandler(CLICK_APPLY, {
          'Click Type': 'Apply',
          'Click ID': trackingMetadata.clickId,
          'Page Form Factor': getMrphPageFormFactor(),
          'Page Position': props.pagePosition,
        });

        windowReference.location =
          plantMetadataInLocalStorageAndReturnTransferUrl(
            trackingMetadata.partnerUrl,
            id,
          );
      })
      .catch(err => {
        logger.showError('A problem happened while Transferring', err.message);
        logger.reportAPIError(err);
      });
  };

  const onVisibilityChange = isVisible => {
    if (isVisible === true && !isSeenTriggered) {
      defaultEventHandler(SEEN_OFFER, {});
      setIsSeenTriggered(true);
    }
  };

  return (
    <props.businessLoanTemplate
      clickApplyHandler={onApplyClick}
      clickApplyLoanNameHandler={onApplyClickForName}
      clickApplyImageHandler={onApplyClickForImage}
      pagePosition={props.pagePosition}
      seenPixel={
        <VisibilitySensor onChange={onVisibilityChange}>
          <div className="invisible-pixel" />
        </VisibilitySensor>
      }
      {...props}
    />
  );
};

BusinessLoanOfferHolder.defaultProps = {
  extraEventAttributes: {},
};

const connectedBusinessLoanOfferHolder = withRouter(BusinessLoanOfferHolder);
export { connectedBusinessLoanOfferHolder as BusinessLoanOfferHolder };
